// 'use server'

import { sendContact } from '@/services'
import yup from '@/utils/yup-global'
import { contactSchema } from '@/validations'

export const SubmitContactForm = async (values: yup.InferType<typeof contactSchema>) => {
  try {
    const res = await sendContact({ params: { ...values } })
    return res
  } catch (error) {
    console.error('Submit contact form error:', error)
    throw error
  }
}
